(function ($) {
  $(document).ready(function () {
    let portfolioWrapper = $(".portfolio-logo-grid");
    if (portfolioWrapper && portfolioWrapper.length) {
      $(".button-wrapper a").on("click", function (e) {
        e.preventDefault(); // Prevent default link behavior

        var filterVal = $(this).data("id"); // Get the data-id of clicked a tag

        // Add active class to the clicked item and remove from others
        $(".button-wrapper li").removeClass("active");
        $(this).parent("li").addClass("active");

        // Show items based on the filter value
        if (filterVal === "all") {
          // Show all items if 'all' is clicked
          $(".items").show();
        } else {
          // Hide all items, then show the ones that match the filter
          $(".items").hide();
          $(".items").each(function () {
            if ($(this).data("val") === filterVal) {
              $(this).show();
            }
          });
        }
      });
    }
  });
})(jQuery);
